import { Monitor, Smartphone, Tablet, type LucideIcon } from 'lucide-react';

const BROWSERS: Array<[RegExp, string]> = [
  [/Edg[e/]/, 'Edge'],
  [/OPR|Opera/, 'Opera'],
  [/Chrome|CriOS/, 'Chrome'],
  [/Firefox|FxiOS/, 'Firefox'],
  [/Safari/, 'Safari'],
];

const PLATFORMS: Array<[RegExp, string]> = [
  [/iPhone|iPod/, 'iOS'],
  [/iPad/, 'iPadOS'],
  [/Android/, 'Android'],
  [/Mac OS X|Macintosh/, 'macOS'],
  [/Windows/, 'Windows'],
  [/CrOS/, 'ChromeOS'],
  [/Linux/, 'Linux'],
];

/**
 * Browser name from a user-agent string. Edge and Opera are tested before
 * Chrome because both include "Chrome" in their UA, and Chrome before Safari
 * because Chrome's UA also ends in "Safari".
 */
export function browserFromUserAgent(userAgent?: string | null): string | null {
  if (!userAgent) return null;
  return BROWSERS.find(([pattern]) => pattern.test(userAgent))?.[1] ?? null;
}

/** Operating system from a user-agent string. iPad is tested before macOS. */
export function platformFromUserAgent(userAgent?: string | null): string | null {
  if (!userAgent) return null;
  return PLATFORMS.find(([pattern]) => pattern.test(userAgent))?.[1] ?? null;
}

/** Icon matching the device class, for a sessions list. */
export function deviceIconFromUserAgent(userAgent?: string | null): LucideIcon {
  if (!userAgent) return Monitor;
  if (/iPad|Tablet/.test(userAgent)) return Tablet;
  if (/iPhone|iPod|Android.*Mobile|Mobile/.test(userAgent)) return Smartphone;
  return Monitor;
}
